import react, { useReducer, useMemo } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { Box, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material'
import Table from '../../Table'
import { DatePicker, DateTimeField } from '@mui/x-date-pickers'
import { number2dayweek } from '../../Utils/dayjsptbrhelper'
import dayjs from 'dayjs'
import { customTheme } from '../../theme/textfieldTheme';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import ColorButton from '../../Buttons/ColorButton'
import { incentivos } from './entrada'

const getcolumns = () => {
    const columns = []
    columns.push({field: 'tipo_incentivo', headerName: 'Tipo Incentivo'})
    columns.push({field: 'filial', headerName: 'Filial', width: 5})
    columns.push({field: 'numNF', headerName: 'Núm. NF'})
    columns.push({field: 'codpro', headerName: 'codpro'})
    columns.push({field: 'dtemissao', headerName: 'Dt. Emissão', flex:1})
    columns.push({field: 'saldosaida', headerName: 'Saldo NF Saída', flex:1})
    columns.push({field: 'qtde', headerName: 'Qtde Saida realizada', flex:1})
    return columns
}

const initial_state ={
    dataini: '',
    dataend: '',
    numeronf: '',
    tipoincentivo: '',
    baseicmsitem: ''
}

const NFSSaida = () => {

    const [state, setState] = useReducer(lockedReducer, {
        ...initial_state,
        edit: null,
        rows: []
    })

    const outerTheme = useTheme();

    return (
        <>
            <Box className='nfssaida-mainframe'>
                <ThemeProvider theme={customTheme(outerTheme)}>
                    <Box sx={{ flex: .15 }} className='nfssaida-filters'>
                        <Box className='filter-items'>
                            <FormControl sx={{ width: '13rem' }} size="small">
                                <InputLabel id="demo-simple-select-label">Tipo Incentivo</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Tipo Incentivo"
                                    value={state.tipoincentivo}
                                    onChange={(e) => setState({ tipoincentivo: e.target.value })}
                                >
                                    {
                                        Object.entries(incentivos).map(([key, value]) => (
                                            <MenuItem key={key} value={key}>{value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                            <TextField
                                size='small'
                                value={state.numeronf}
                                onChange={({ target }) => setState({ numeronf: target.value })}
                                label='Número NF'
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Cheg. Inicial"
                                size="small"
                                value={dayjs(state.dataini)}
                                onChange={(e) => setState({ dataini: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small' } }}
                                label="Dt. Cheg. Final"
                                size="small"
                                value={dayjs(state.dataend)}
                                onChange={(e) => setState({ dataend: e.format('YYYY-MM-DD') })}
                                format='DD/MM/YYYY'
                                dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                sx={{ width: '11rem' }}
                            />

                        </Box>
                        <Box className='filter-buttons'>
                            <ColorButton>
                                Localizar
                            </ColorButton>
                            <ColorButton onClick={() => setState(initial_state)}>
                                Limpar filtros
                            </ColorButton>
                        </Box>
                    </Box>
                </ThemeProvider>
                <Box sx={{ flex: .85, overflow:'hidden' }}>
                    <Table
                        paginationMode='client'
                        className='alterned_grid contabil-grid'
                        rows={state.rows}
                        columns={useMemo(()=> getcolumns(setState), [state.rows, state.edit])}
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        pagination={false}
                        density='compact'
                        rowHeight={30}
                    />
                </Box>
            </Box>
        </>
    )

}

export default NFSSaida